import type { SpaceConfig } from "@cloudnest/stone-flicking-core-engine/types";
import type { InitialEntitySeed } from "../types/game-config";

function generateSectorSeeds(
  playerIndex: number,
  playerCount: 2 | 3 | 4,
  stonesPerPlayer: number,
  space: SpaceConfig,
): ReadonlyArray<InitialEntitySeed> {
  const sectorAngle = (2 * Math.PI) / playerCount;
  const startAngle = playerIndex * sectorAngle + sectorAngle / 2;

  const placementRadius = space.radius * 0.65;
  const seeds: InitialEntitySeed[] = [];

  const rows = stonesPerPlayer <= 4 ? 2 : 3;
  const stonesPlaced: Array<{ x: number; y: number }> = [];

  let remaining = stonesPerPlayer;
  for (let row = 0; row < rows && remaining > 0; row++) {
    const rowRadius = placementRadius - row * (space.radius * 0.15);
    const stonesInRow = Math.min(
      remaining,
      row === 0 ? Math.ceil(stonesPerPlayer / rows) : remaining,
    );

    for (let col = 0; col < stonesInRow; col++) {
      const angleSpread = sectorAngle * 0.5;
      const angleOffset =
        stonesInRow === 1
          ? 0
          : -angleSpread / 2 + (angleSpread / (stonesInRow - 1)) * col;

      const angle = startAngle + angleOffset;
      const x = space.centerX + rowRadius * Math.cos(angle);
      const y = space.centerY + rowRadius * Math.sin(angle);

      stonesPlaced.push({ x, y });
      seeds.push({
        id: `p${playerIndex}-stone-${seeds.length + 1}`,
        archetype: "STONE",
        ownerIndex: playerIndex,
        x: Math.round(x * 100) / 100,
        y: Math.round(y * 100) / 100,
      });

      remaining--;
    }
  }

  return seeds;
}

export function generateDeploymentSeeds(
  playerCount: 2 | 3 | 4,
  stonesPerPlayer: number,
  space: SpaceConfig,
): ReadonlyArray<InitialEntitySeed> {
  const allSeeds: InitialEntitySeed[] = [];

  for (let i = 0; i < playerCount; i++) {
    const playerSeeds = generateSectorSeeds(
      i,
      playerCount,
      stonesPerPlayer,
      space,
    );
    allSeeds.push(...playerSeeds);
  }

  return allSeeds;
}

export function getStonesPerPlayer(playerCount: 2 | 3 | 4): number {
  switch (playerCount) {
    case 2:
      return 6;
    case 3:
      return 4;
    case 4:
      return 3;
  }
}
